import React, { useEffect } from "react";
import { Observer } from "mobx-react";
import { useStores } from "../../store";
import { MeetingCreationForm } from "./MeetingCreation";
import { toJS } from "mobx";
export default function TopicBasedInterview({
  popUpInitialValue,
  handlePopup,
  takeInterview = false,
}) {
  const { PopupStore, UserStore, InterviewStore } = useStores();
  useEffect(() => {
    console.log(toJS(InterviewStore.interviewSettings));
        // alert("Interview ID: ");
  }, [ InterviewStore.interviewSettings]);

  return (
    <Observer>
      {() => (
        <>
          {popUpInitialValue ? (
            <div
              className={`${
                PopupStore.topicbasedinterview
                  ? "absolute w-screen h-screen z-40 backdrop-filter backdrop-blur-sm bg-black bg-opacity-40 flex justify-center items-center"
                  : null
              }`}>
              <div className=" lg:w-[30%]">
                <MeetingCreationForm
                  showMeeting={true}
                  takeInterview={takeInterview}
                />
              </div>
            </div>
          ) : null}
        </>
      )}
    </Observer>
  );
}
